// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const stepTemplatesSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  title: z.string().max(500),
  description: z.string().max(100000).optional(),
  category: z.string().max(200),
  stepType: z.string().max(200),
  action: z.record(z.string(), z.unknown()),
  inputs: z.record(z.string(), z.unknown()).optional(),
  outputs: z.record(z.string(), z.unknown()).optional(),
  outputExtraction: z.record(z.string(), z.unknown()).optional(),
  requiredVariables: z.array(z.string()).optional(),
  cli: z.record(z.string(), z.unknown()).optional(),
  versionField: z.string().max(200).optional(),
  tags: z.array(z.string()).optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type StepTemplatesInput = z.infer<typeof stepTemplatesSchema>
